const ButtonStyles = {
  variant: 'outlined',
  size: 'large',
  style: {
    backgroundColor: 'orange',
    borderColor: 'orange',
  },
} as const;

export { ButtonStyles };
